module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row pb-4"
  }, [_c('div', {
    staticClass: "col-md-6 px-5 bg-lightest border-light"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "d-flex w-100 mt-3"
  }, [_c('div', {
    staticClass: "d-flex flex-column w-50 fields-min-height mr-3"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.promocode.code),
      expression: "promocode.code"
    }],
    attrs: {
      "name": "code",
      "type": "text"
    },
    domProps: {
      "value": (_vm.promocode.code)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.promocode, "code", $event.target.value)
      }, _vm.$v.promocode.code.$touch]
    }
  }), _vm._v(" "), (_vm.$v.promocode.code.$invalid) ? _c('div', [(!_vm.$v.promocode.code.required) ? _c('span', {
    staticClass: "fs-small error"
  }, [_vm._v("Code is required")]) : _vm._e(), _vm._v(" "), (!_vm.$v.promocode.code.minLength) ? _c('span', {
    staticClass: "fs-small error"
  }, [_vm._v("Code must have at least " + _vm._s(_vm.$v.promocode.code.$params.minLength.min) + " characters")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column w-50 fields-min-height ml-3"
  }, [_c('label', {
    attrs: {
      "for": "code"
    }
  }, [_vm._v("Campaign Type")]), _vm._v(" "), _c('v-select', {
    staticClass: "flex-grow-0",
    attrs: {
      "options": _vm.getPromocodeAudience
    },
    on: {
      "input": _vm.audinceChanged
    },
    model: {
      value: (_vm.selectedAudience),
      callback: function($$v) {
        _vm.selectedAudience = $$v
      },
      expression: "selectedAudience"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex w-100 mt-3"
  }, [_c('div', {
    staticClass: "d-flex flex-column w-50 mr-3 fields-min-height"
  }, [_c('label', {
    attrs: {
      "for": "discount"
    }
  }, [_vm._v(_vm._s(_vm.discountLabel)), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.promocode.value),
      expression: "promocode.value"
    }],
    staticClass: "glued-right w-100",
    attrs: {
      "name": "discount",
      "type": "number"
    },
    domProps: {
      "value": (_vm.promocode.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.promocode, "value", $event.target.value)
      }, _vm.$v.promocode.value.$touch]
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "glued-left select-width",
    attrs: {
      "options": _vm.getPercentageOrCurrency
    },
    on: {
      "input": _vm.discountTypeChanged
    },
    model: {
      value: (_vm.selectedDiscountType),
      callback: function($$v) {
        _vm.selectedDiscountType = $$v
      },
      expression: "selectedDiscountType"
    }
  })], 1), _vm._v(" "), (_vm.$v.promocode.value.$invalid) ? _c('div', [(!_vm.$v.promocode.value.required) ? _c('span', {
    staticClass: "fs-small error"
  }, [_vm._v(_vm._s(_vm.discountLabel) + " is required")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column w-50 ml-3 fields-min-height"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.promocode.maxQuantity),
      expression: "promocode.maxQuantity"
    }],
    attrs: {
      "name": "max",
      "type": "number",
      "placeholder": "E.g., 50"
    },
    domProps: {
      "value": (_vm.promocode.maxQuantity)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.promocode, "maxQuantity", $event.target.value)
      }, _vm.$v.promocode.maxQuantity.$touch]
    }
  }), _vm._v(" "), (_vm.$v.promocode.maxQuantity.$invalid) ? _c('div', [(!_vm.$v.promocode.maxQuantity.required) ? _c('span', {
    staticClass: "fs-small error"
  }, [_vm._v("Max. quantity is required")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column my-3"
  }, [_c('label', [_vm._v("Promocode Type")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex mt-2"
  }, [_c('radio', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.disableTooltip),
      expression: "disableTooltip"
    }],
    staticClass: "mr-5",
    attrs: {
      "name": "perperson",
      "disabled": _vm.disableEdit,
      "value": true
    },
    model: {
      value: (_vm.promocode.isMaxQuantityPerPerson),
      callback: function($$v) {
        _vm.$set(_vm.promocode, "isMaxQuantityPerPerson", $$v)
      },
      expression: "promocode.isMaxQuantityPerPerson"
    }
  }, [_vm._v("Per Person")]), _vm._v(" "), _c('radio', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.disableTooltip),
      expression: "disableTooltip"
    }],
    attrs: {
      "name": "perbooking",
      "disabled": _vm.disableEdit,
      "value": false
    },
    model: {
      value: (_vm.promocode.isMaxQuantityPerPerson),
      callback: function($$v) {
        _vm.$set(_vm.promocode, "isMaxQuantityPerPerson", $$v)
      },
      expression: "promocode.isMaxQuantityPerPerson"
    }
  }, [_vm._v("Per Booking")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column mt-3"
  }, [_c('label', {
    attrs: {
      "for": "note"
    }
  }, [_vm._v("Note")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.promocode.note),
      expression: "promocode.note"
    }],
    attrs: {
      "name": "note",
      "rows": "10",
      "placeholder": "Notes about this promocode goes here..."
    },
    domProps: {
      "value": (_vm.promocode.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.promocode, "note", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 pr-0"
  }, [_c('div', {
    staticClass: "col-sm-12 border-light bg-lightest px-5 py-4"
  }, [_c('h5', {
    staticClass: "fs-large bold mb-4"
  }, [_vm._v("Promocode is valid when booked between")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('date-picker-new', {
    staticClass: "dateRangePicker",
    attrs: {
      "range": true,
      "enableClear": false,
      "clearOutside": true,
      "showFromTo": false
    },
    on: {
      "input": function($event) {
        return _vm.bookingPeriodChanged($event)
      }
    },
    model: {
      value: (_vm.bookingPeriod),
      callback: function($$v) {
        _vm.bookingPeriod = $$v
      },
      expression: "bookingPeriod"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mx-3"
  }, [_vm._v("and")])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mt-3"
  }, [_c('span', {
    staticClass: "mr-3"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.getPromocodeDaysInAdvance
    },
    on: {
      "input": _vm.bookingBeforeChanged
    },
    model: {
      value: (_vm.selectedBookingBefore),
      callback: function($$v) {
        _vm.selectedBookingBefore = $$v
      },
      expression: "selectedBookingBefore"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("before activity start.")])]), _vm._v(" "), (_vm.$v.promocode.bookingPeriodStart.$dirty) ? _c('div', {
    staticClass: "d-flex flex-column"
  }, [(!_vm.$v.promocode.bookingPeriodStart.required) ? _c('span', {
    staticClass: "fs-small error"
  }, [_vm._v("Booking period start is Required")]) : _vm._e(), _vm._v(" "), (!_vm.$v.promocode.bookingPeriodStart.lowerThanBookingPeriodFinish) ? _c('span', {
    staticClass: "fs-small error"
  }, [_vm._v("Booking period start must be lower or equal to finish date")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$v.promocode.bookingPeriodFinish.$dirty) ? _c('div', {
    staticClass: "d-flex flex-column"
  }, [(!_vm.$v.promocode.bookingPeriodFinish.required) ? _c('span', {
    staticClass: "fs-small error"
  }, [_vm._v("Booking period end is Required")]) : _vm._e(), _vm._v(" "), (!_vm.$v.promocode.bookingPeriodFinish.higherThanBookingPeriodStart) ? _c('span', {
    staticClass: "fs-small error"
  }, [_vm._v("Booking period end must be higher or equal to start date")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 border-light bg-lightest mt-3 px-5 py-4"
  }, [_c('h5', {
    staticClass: "fs-large bold mb-4"
  }, [_vm._v("For activities that happen between")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('date-picker-new', {
    staticClass: "dateRangePicker",
    attrs: {
      "range": true,
      "enableClear": false,
      "clearOutside": true,
      "showFromTo": false
    },
    on: {
      "input": function($event) {
        return _vm.validPeriodFinishChanged($event)
      }
    },
    model: {
      value: (_vm.validPeriod),
      callback: function($$v) {
        _vm.validPeriod = $$v
      },
      expression: "validPeriod"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column pt-4 align-items-start"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column weeks-min-height"
  }, [_c('week-day-picker', {
    attrs: {
      "dateRange": _vm.validPeriod
    },
    on: {
      "change": _vm.$v.promocode.validDaysOfWeek.$touch,
      "hasWeekDays": function($event) {
        return _vm.weekDaysValidation($event)
      }
    },
    model: {
      value: (_vm.promocode.validDaysOfWeek),
      callback: function($$v) {
        _vm.$set(_vm.promocode, "validDaysOfWeek", $$v)
      },
      expression: "promocode.validDaysOfWeek"
    }
  })], 1)]), _vm._v(" "), (_vm.haveValidHoursInterval == true) ? _c('div', {
    staticClass: "pt-3"
  }, [_c('label', {
    staticClass: "mb-1"
  }, [_vm._v("Starting hour is between")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticStyle: {
      "width": "95px"
    }
  }, [_c('timepicker', {
    attrs: {
      "defaultTime": _vm.validPeriodStartTime,
      "disabled": false
    },
    on: {
      "change": function($event) {
        return _vm.validHourChanged($event, 'start')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mx-3"
  }, [_vm._v("and")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "95px"
    }
  }, [_c('timepicker', {
    attrs: {
      "defaultTime": _vm.validPeriodFinishTime,
      "disabled": false
    },
    on: {
      "change": function($event) {
        return _vm.validHourChanged($event, 'finsh')
      }
    }
  })], 1)]), _vm._v(" "), (_vm.$v.promocode.validPeriodHourInterval.$invalid) ? _c('div', [(!_vm.$v.promocode.validPeriodHourInterval.isValid) ? _c('span', {
    staticClass: "fs-small error"
  }, [_vm._v("Start hour must be before ending hour")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "errors-min-height mt-1"
  }, [(_vm.$v.promocode.validPeriodStart.$invalid) ? _c('div', {
    staticClass: "d-flex flex-column"
  }, [(!_vm.$v.promocode.validPeriodStart.required) ? _c('span', {
    staticClass: "fs-small error"
  }, [_vm._v("Start valid period is Required")]) : _vm._e(), _vm._v(" "), (!_vm.$v.promocode.validPeriodStart.lowerThanValidPeriodFinish) ? _c('span', {
    staticClass: "fs-small error"
  }, [_vm._v("Start valid period must be lower or equal to finish date")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$v.promocode.validPeriodFinish.$invalid) ? _c('div', {
    staticClass: "d-flex flex-column"
  }, [(!_vm.$v.promocode.validPeriodFinish.required) ? _c('span', {
    staticClass: "fs-small error"
  }, [_vm._v("End valid period is Required")]) : _vm._e(), _vm._v(" "), (!_vm.$v.promocode.validPeriodFinish.higherThanValidPeriodStart) ? _c('span', {
    staticClass: "fs-small error"
  }, [_vm._v("End valid period must be higher or equal to start date")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 border-light bg-lightest mt-3 px-5 py-4 prod-selection-min-height"
  }, [_c('h5', {
    staticClass: "fs-large bold mb-4"
  }, [_vm._v("Product selection")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('radio', {
    staticClass: "mr-3",
    attrs: {
      "name": "allProducts",
      "value": true
    },
    on: {
      "input": _vm.$v.promocode.products.$touch
    },
    model: {
      value: (_vm.promocode.isForAllProducts),
      callback: function($$v) {
        _vm.$set(_vm.promocode, "isForAllProducts", $$v)
      },
      expression: "promocode.isForAllProducts"
    }
  }, [_vm._v("All Products")]), _vm._v(" "), _c('radio', {
    attrs: {
      "name": "allProducts",
      "value": false
    },
    on: {
      "input": _vm.$v.promocode.products.$touch
    },
    model: {
      value: (_vm.promocode.isForAllProducts),
      callback: function($$v) {
        _vm.$set(_vm.promocode, "isForAllProducts", $$v)
      },
      expression: "promocode.isForAllProducts"
    }
  }, [_vm._v("Selected Products")])], 1), _vm._v(" "), (_vm.promocode.isForAllProducts == true) ? _c('div', {
    staticClass: "mt-2 text-center p-5 dark"
  }, [_vm._v("\n                    All products will be on this promocode\n                ")]) : _c('div', {
    staticClass: "mt-3"
  }, [(_vm.promocode.products.length > 0) ? _c('div', {
    staticClass: "d-flex flex-column"
  }, _vm._l((_vm.promocode.products), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "d-flex align-items-center mb-2"
    }, [_c('v-select', {
      staticClass: "openUp",
      attrs: {
        "options": _vm.getProducts,
        "placeholder": "Select a product",
        "label": "name"
      },
      model: {
        value: (_vm.promocode.products[index]),
        callback: function($$v) {
          _vm.$set(_vm.promocode.products, index, $$v)
        },
        expression: "promocode.products[index]"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fas fa-trash-alt dark ml-3 pointer",
      on: {
        "click": function($event) {
          return _vm.removeProduct(index)
        }
      }
    })], 1)
  }), 0) : _c('div', {
    staticClass: "text-center p-2 dark"
  }, [_vm._v("\n                        Please add a product to this list\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "add d-flex align-items-center pointer fs-small bold mt-3",
    on: {
      "click": _vm.addProduct
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add Product\n                    ")]), _vm._v(" "), (_vm.$v.promocode.products.$dirty) ? _c('div', {
    staticClass: "mt-3"
  }, [(!_vm.$v.promocode.products.validProduct) ? _c('span', {
    staticClass: "fs-small error"
  }, [_vm._v("Select at least one product")]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-4"
  }, [_c('h5', {
    staticClass: "fs-large bold mr-2"
  }, [_vm._v("Campaign details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "code"
    }
  }, [_vm._v("Code"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "max"
    }
  }, [_vm._v("Max. Quantity"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mb-1"
  }, [_vm._v("Day selection"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4a57e399", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a57e399"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/promocodes/components/promocodeForm.vue
// module id = 3115
// module chunks = 0